import gql from 'graphql-tag';
export default gql`
  mutation UpdateContactById($input: UpdateContactByIdInput!) {
    updateContactById(input: $input) {
      clientMutationId
    }
  }
`;
